function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.414 61l29.699-29.699c16.402-16.402 42.995-16.402 59.398 0 16.402 16.402 16.402 42.996 0 59.398-16.403 16.402-42.996 16.402-59.398 0L1.414 61z",
  stroke: "currentColor",
  strokeWidth: 2
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M68.927 77.902A19.077 19.077 0 0174.531 64.6c7.474-7.474 7.474-19.592 0-27.067-7.474-7.474-19.592-7.474-27.066 0s-7.474 19.593 0 27.067a19.077 19.077 0 015.604 13.302",
  stroke: "currentColor",
  strokeWidth: 2
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M61 42.035l-3.435 12.883h6.87L61 67.8M50.882 78.134h20.232M50.882 82.509h20.232M50.882 86.884h20.232M55.256 91.258H66.74",
  stroke: "currentColor",
  strokeWidth: 2
});

var SvgEmblemInnovation = function SvgEmblemInnovation(props) {
  return React.createElement("svg", _extends({
    width: 122,
    height: 122,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgEmblemInnovation;